import styled from "styled-components";
import {LabelInputType} from "@dropDesk/presentation/components/inputs/input_with_border/input_with_border";

export const Label = styled.span<LabelInputType>`
  font-size: 14px;
  color: ${props => props.color};
  margin: 0 0 1px 2px;
`;
